import {
  Directive,
  ElementRef,
  HostListener,
  OnInit,
  Inject,
  LOCALE_ID,
  Input
} from '@angular/core';
import {
  DecimalPipe,
  getLocaleNumberSymbol,
  NumberSymbol
} from '@angular/common';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';

@Directive({
  selector: '[abAmountFormatter]'
})
export class AmountFormatterDirective implements OnInit {
  @Input() pipeFormat: string;
  private el: HTMLInputElement;
  private valueChangesSubscription: Subscription;

  constructor(
    elementRef: ElementRef,
    private decimalPipe: DecimalPipe,
    private control: NgControl,
    @Inject(LOCALE_ID) private locale: string
  ) {
    this.el = elementRef.nativeElement;
  }

  ngOnInit() {
    this.format(this.control.control.value);
    this.valueChangesSubscription = this.control.control.valueChanges.subscribe(
      value => this.format(value)
    );
  }

  private format(value): void {
    this.el.value = this.decimalPipe.transform(
      value,
      this.pipeFormat || '1.0-0'
    );
  }

  @HostListener('input', ['$event.target.value'])
  onInput(value) {
    // Check if '.' sign is allowed for this input when the input need to show fraction part of decimal number
    if (this.pipeFormat && this.pipeFormat.split('-')[0].indexOf('2') !== 0) {
      this.el.value = value.replace(/[^0-9\.]/g, '');
      this.control.control.patchValue(value.replace(/[^0-9\.]/g, ''));
    } else {
      this.el.value = value.replace(/\D/g, '');
      this.control.control.patchValue(value.replace(/\D/g, ''));
    }
  }

  @HostListener('focus')
  onFocus() {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
      this.valueChangesSubscription = undefined;
    }

    const regex = new RegExp(
      `\\${getLocaleNumberSymbol(this.locale, NumberSymbol.Group)}`,
      'g'
    );
    this.el.value = this.el.value.replace(regex, '');
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    if (!parseFloat(value)) {
      return;
    }

    const amount = this.decimalPipe.transform(
      value,
      this.pipeFormat || '1.0-0'
    );

    this.control.control.patchValue(parseFloat(value.replace(',', '.')));
    this.el.value = amount;
  }
}
